// extracted by mini-css-extract-plugin
module.exports = {"ariaSkipLinksContainer":"_i-z"};